import httpService from '../httpService';
import { ApiResponse } from '../../types/api';

export async function patch<T>(url: string, data?: any): Promise<ApiResponse<T>> {
  const response = await httpService.patch<ApiResponse<T>>(url, data);
  return response.data;
}
